import MarketInsightsSignStackChart from "../charts/MarketInsightsSignStackChart";
import MarketInsightsLMPChart from "../charts/MarketInsightsLMPChart";
import MarketInsightsBiaxialLineChart from "../charts/MarketInsightsBiaxialLineChart";
import MarketInsightsLineForecastChart from "../charts/MarketInsightsLineForecastChart";
import OutageChart, { mockWindSolarData, mockThermalData } from "../charts/MarketInsightsOutageChart";
import MarketInsightsStackedAreaChart, { mockERCOTData } from "../charts/MarketInsightsStackedAreaChart";
import ChartWrapper from "../charts/ChartWrapper";
import {
    UnauthenticatedTemplate,
    AuthenticatedTemplate,
    ReadAccessUnauthorizedTemplate,
    ReadAccessAuthorizedTemplate,
} from "../hooks/useAuth";

const MarketInsightsPage = () => {
    return (
        <div className="flex bg-gray-200 dark:bg-gray-900 h-dvh z-0 max-w-screen">
<UnauthenticatedTemplate>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                    }}
                >
                    <p>Please sign in to view this content!</p>
                    <button
                        onClick={() => {
                            window.location.href = "/.auth/login/aad";
                        }}
                        className="px-[6px] h-[30px] mt-1 rounded-[3px] bg-accent1 hover:bg-accent2 duration-300 text-white text-[13px] font-semibold"
                    >
                        Sign In
                    </button>
                </div>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <ReadAccessUnauthorizedTemplate>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100%",
                        }}
                    >
                        <p>
                            To view this content, please contact us at{" "}
                            <a href="mailto:services@grid-insights.net">
                                services@grid-insights.net
                            </a>
                            !
                        </p>
                    </div>
                </ReadAccessUnauthorizedTemplate>
                <ReadAccessAuthorizedTemplate>
            <div className="p-6 bg-gray-200 dark:bg-gray-900 h-[100vh] overflow-y-auto">
                <div className="w-full h-full flex flex-col">
                    <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 text-center flex-shrink-0">
                        Market Insights
                    </h1>
                    
                    <div className="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-6 flex-1 auto-rows-fr">
                        <ChartWrapper title="Map Placeholder">
                            <div className="w-full h-full bg-gray-200 dark:bg-[#2D3748] rounded-lg"></div>
                        </ChartWrapper>

                        <ChartWrapper title="Fuel Mix - ERCOT">
                            <MarketInsightsStackedAreaChart
                                data={mockERCOTData}
                                unit="GW"
                            />
                        </ChartWrapper>

                        <ChartWrapper title="Locational Marginal Price - ERCOT">
                            <MarketInsightsLMPChart />
                        </ChartWrapper>

                        <ChartWrapper title="Load - ERCOT">
                            <MarketInsightsLineForecastChart />
                        </ChartWrapper>
                  
                        <ChartWrapper title="ERCOT - Wind + Solar Generation Outages and Outlook">
                            <OutageChart
                                data={mockWindSolarData}
                                fuelTypes={['wind_solar']}
                                fuelTypeLabels={{
                                    wind_solar: 'Wind + Solar'
                                }}
                                unit="MW"
                                currentTime="2025-06-16T12:00:00Z"
                            />
                        </ChartWrapper>

                        <ChartWrapper title="ERCOT - Thermal Generation Outages and Outlook">
                            <OutageChart
                                data={mockThermalData}
                                fuelTypes={['thermal']}
                                fuelTypeLabels={{
                                    thermal: 'Thermal'
                                }}
                                unit="MW"
                                currentTime="2025-06-16T12:00:00Z"
                            />
                        </ChartWrapper>

                        <ChartWrapper title="Renewables - ERCOT">
                            <MarketInsightsBiaxialLineChart />
                        </ChartWrapper>

                        <ChartWrapper title="ERCOT Storage">
                            <MarketInsightsSignStackChart />
                        </ChartWrapper>
                    </div>
                </div>
            </div>
            </ReadAccessAuthorizedTemplate>
            </AuthenticatedTemplate>
        </div>
    );
};

export default MarketInsightsPage;
